"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxesCounts = exports.customEscape = exports.isCssMultiLineTruncationSupported = exports.percentFormatter = exports.unwrap = exports.getPrimaryChartType = exports.formatLegendLabel = exports.stringifyChartTypes = exports.isOneOfTypes = exports.isChartSupported = exports.isInvertedChartType = exports.isSupportingJoinedAttributeAxisName = exports.isFunnel = exports.isHeatmap = exports.isTreemap = exports.isComboChart = exports.isBubbleChart = exports.isAreaChart = exports.isPieOrDonutChart = exports.isDonutChart = exports.isPieChart = exports.isScatterPlot = exports.isLineChart = exports.isBulletChart = exports.isBarChart = exports.isColumnChart = exports.isRotationInRange = exports.unEscapeAngleBrackets = exports.repeatItemsNTimes = exports.immutableSet = exports.parseValue = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var clone_1 = tslib_1.__importDefault(require("lodash/clone"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var setWith_1 = tslib_1.__importDefault(require("lodash/setWith"));
var numberjs_1 = require("@gooddata/numberjs");
var escape_1 = tslib_1.__importDefault(require("lodash/escape"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var unescape_1 = tslib_1.__importDefault(require("lodash/unescape"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var format_1 = require("../../constants/format");
function parseValue(value) {
    var parsedValue = parseFloat(value);
    return isNaN(parsedValue) ? null : parsedValue;
}
exports.parseValue = parseValue;
exports.immutableSet = function (dataSet, path, newValue) { return setWith_1.default(tslib_1.__assign({}, dataSet), path, newValue, clone_1.default); };
exports.repeatItemsNTimes = function (array, n) {
    return new Array(n).fill(null).reduce(function (result) {
        result.push.apply(result, array);
        return result;
    }, []);
};
exports.unEscapeAngleBrackets = function (str) { return str === null || str === void 0 ? void 0 : str.replace(/&lt;|&#60;/g, "<").replace(/&gt;|&#62;/g, ">"); };
function isRotationInRange(rotation, min, max) {
    return rotation >= min && rotation <= max;
}
exports.isRotationInRange = isRotationInRange;
/**
 * @internal
 */
exports.isColumnChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.COLUMN);
/**
 * @internal
 */
exports.isBarChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.BAR);
/**
 * @internal
 */
exports.isBulletChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.BULLET);
/**
 * @internal
 */
exports.isLineChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.LINE);
/**
 * @internal
 */
exports.isScatterPlot = isEqual_1.default(sdk_ui_1.VisualizationTypes.SCATTER);
/**
 * @internal
 */
exports.isPieChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.PIE);
/**
 * @internal
 */
exports.isDonutChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.DONUT);
/**
 * @internal
 */
exports.isPieOrDonutChart = function (type) { return exports.isPieChart(type) || exports.isDonutChart(type); };
/**
 * @internal
 */
exports.isAreaChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.AREA);
/**
 * @internal
 */
exports.isBubbleChart = isEqual_1.default(sdk_ui_1.VisualizationTypes.BUBBLE);
/**
 * @internal
 */
exports.isComboChart = function (type) {
    return isEqual_1.default(type, sdk_ui_1.VisualizationTypes.COMBO) || isEqual_1.default(type, sdk_ui_1.VisualizationTypes.COMBO2);
};
/**
 * @internal
 */
exports.isTreemap = isEqual_1.default(sdk_ui_1.VisualizationTypes.TREEMAP);
/**
 * @internal
 */
exports.isHeatmap = isEqual_1.default(sdk_ui_1.VisualizationTypes.HEATMAP);
/**
 * @internal
 */
exports.isFunnel = isEqual_1.default(sdk_ui_1.VisualizationTypes.FUNNEL);
/**
 * @internal
 */
exports.isSupportingJoinedAttributeAxisName = function (type) {
    return exports.isBarChart(type) || exports.isColumnChart(type) || exports.isBulletChart(type);
};
/**
 * @internal
 */
exports.isInvertedChartType = function (type) { return exports.isBarChart(type) || exports.isBulletChart(type); };
exports.isChartSupported = function (type) { return includes_1.default(sdk_ui_1.VisualizationTypes, type); };
exports.isOneOfTypes = function (type, types) { return includes_1.default(types, type); };
exports.stringifyChartTypes = function () {
    return Object.keys(sdk_ui_1.VisualizationTypes)
        .reduce(function (acc, type) {
        acc.push(sdk_ui_1.VisualizationTypes[type]);
        return acc;
    }, [])
        .join(", ");
};
function formatLegendLabel(value, format, diff, numericSymbols) {
    if (format === null || format === void 0 ? void 0 : format.includes("%")) {
        return numberjs_1.numberFormat(value, "#,#0%");
    }
    var sign = Math.sign(value) === -1 ? "-" : "";
    var positiveValue = Math.abs(value);
    var formattingString = "";
    if (diff < 10) {
        formattingString += "[<1]0.00;[<10]#.#;[<100]#.#;";
    }
    var k = diff < 10000
        ? "[<999500]0;"
        : "[<1000]0;[<10000]#.#," + numericSymbols[0] + ";[<999500]#," + numericSymbols[0] + ";";
    var m = "[<10000000]#.#,," + numericSymbols[1] + ";[<999500000]#,," + numericSymbols[1] + ";";
    var b = "[<10000000000]#.#,,," + numericSymbols[2] + ";[<999500000000]#,,," + numericSymbols[2] + ";";
    var t = "[<10000000000000]#.#,,," + numericSymbols[3] + ";[>=10000000000000]#,,," + numericSymbols[3];
    formattingString += k + m + b + t;
    return sign + numberjs_1.numberFormat(positiveValue, formattingString);
}
exports.formatLegendLabel = formatLegendLabel;
exports.getPrimaryChartType = function (chartOptions) {
    var _a, _b, _c;
    var series = (_b = (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.data) === null || _a === void 0 ? void 0 : _a.series) !== null && _b !== void 0 ? _b : [];
    var targetSeries = series.find(function (item) { return item.yAxis === 0; });
    return (_c = targetSeries === null || targetSeries === void 0 ? void 0 : targetSeries.type) !== null && _c !== void 0 ? _c : chartOptions.type;
};
exports.unwrap = function (wrappedObject) {
    return wrappedObject[Object.keys(wrappedObject)[0]];
};
var getNumberWithGivenDecimals = function (value, decimalNumbers) {
    return decimalNumbers === 0 ? Math.round(value) + "%" : parseFloat(value.toFixed(decimalNumbers)) + "%";
};
// it calculates number of decimals from default format that contains ',' and '.' as separators
var getNumberOfDecimalsFromDefaultFormat = function (format) {
    var splittedFormat = format.split(format_1.DEFAULT_DECIMAL_SEPARATOR);
    if (splittedFormat.length !== 2) {
        return 0;
    }
    return Array.from(splittedFormat[1]).reduce(function (numberOfDecimals, letter) { return (letter === "0" ? numberOfDecimals + 1 : numberOfDecimals); }, 0);
};
function percentFormatter(value, format) {
    if (isNil_1.default(value)) {
        return "";
    }
    var isPercentageFormat = format && format.trim().slice(-1) === "%";
    var numberOfDecimals = isPercentageFormat ? getNumberOfDecimalsFromDefaultFormat(format) : 2;
    return getNumberWithGivenDecimals(value, numberOfDecimals);
}
exports.percentFormatter = percentFormatter;
exports.isCssMultiLineTruncationSupported = function () {
    // support -webkit-line-clamp
    return "webkitLineClamp" in document.body.style;
};
exports.customEscape = function (str) { return str && escape_1.default(unescape_1.default(str)); };
exports.getAxesCounts = function (config) {
    var _a, _b, _c, _d;
    var hasSecondaryXAxis = config.secondary_xaxis && ((_b = (_a = config.secondary_xaxis) === null || _a === void 0 ? void 0 : _a.measures) === null || _b === void 0 ? void 0 : _b.length) !== 0;
    var hasSecondaryYAxis = config.secondary_yaxis && ((_d = (_c = config.secondary_yaxis) === null || _c === void 0 ? void 0 : _c.measures) === null || _d === void 0 ? void 0 : _d.length) !== 0;
    return [hasSecondaryXAxis ? 2 : 1, hasSecondaryYAxis ? 2 : 1];
};
//# sourceMappingURL=common.js.map